import React from 'react';
import CorpsSection from '../components/CorpsSection';
import Exprience from '../components/Experience';

const Expriences = (props) => {

    return (

        <CorpsSection id="experience" title={props.data.titleBloc}>
            {
                props.data.body.map((exp, index) => (
                    <Exprience key={index} titleJob={exp.titleJob}
                        nameCompany={exp.nameCompany}
                        date={exp.date} >
                        {exp.responsibilities}
                    </Exprience>
                ))}

        </CorpsSection>




    )
};

export default Expriences;